/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.identity.defs'

export { $nsid }

type IdentityInfo = {
  $type?: 'com.atproto.identity.defs#identityInfo'
  did: l.DidString

  /**
   * The validated handle of the account; or 'handle.invalid' if the handle did not bi-directionally match the DID document.
   */
  handle: l.HandleString

  /**
   * The complete DID document for the identity.
   */
  didDoc: l.LexMap
}

export type { IdentityInfo }

const identityInfo = l.typedObject<IdentityInfo>(
  $nsid,
  'identityInfo',
  l.object({
    did: l.string({ format: 'did' }),
    handle: l.string({ format: 'handle' }),
    didDoc: l.lexMap(),
  }),
)

export { identityInfo }
